import React from 'react';
import './intro.css';
import bg from '../../assets/Profile2.png';
import { motion } from 'framer-motion';
// import { Link } from 'react-scroll';

const Intro = () => {
  return (
    <section id='intro'>
        <div className='introContent'>
        <span className='hello'>Hello,</span>
            <span className='introText'>I'm <span className='introName'>Martin</span> <br/>Frontend Developer</span>
            <p className='introPara'>I'm a passionate junior web designer learning to create <br/> visually appealing and user-friendly websites.</p>
            <button className='btnIntro' id="btnIntro">
            <a className='btnA' href="https://api.whatsapp.com/send?phone=543513871701" target="_blank" rel="noreferrer">
                Hire Me
            </a>
            </button>
        </div>
          <motion.img
            src={bg} alt='Profile'
            className='bg' 
            initial={{x:"7rem", opacity:0}}
            animate={{x:0, opacity:1}}
            transition={{duration:2, type:"spring"}}>
          </motion.img>
    </section>
  )
}

export default Intro;
